import React, { useState } from 'react';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';

import { Paragraph, WarningAlert } from 'common/components';
import { useQueryLogin } from 'modules/account/features/login/hooks';

export const ConfirmedRegistration = ({ id }: { id: string }) => {
  const { t } = useTranslation();

  const [closeWarningAlert, setCloseWarningAlert] = useState(true);

  const { error } = useQueryLogin({ id });
  const { colors, fontFamily } = useTheme();

  return (
    <>
      {!error && (
        <WarningAlert
          text={t('Your email address is verified.')}
          confirmInfo
          showCloseIcon={false}
          margin="0.75rem 0 1.5rem 0"
          backgroundColor={colors.white}
        />
      )}

      {error && (
        <WarningAlert
          text={
            <Paragraph
              fontFamily={fontFamily.medium}
              fontSize="0.875rem"
              fontWeight="500"
              margin="0"
              color={colors.black_80}
              display="block"
            >
              {t('Account already verified')}
              <Paragraph
                fontFamily={fontFamily.medium}
                fontSize="0.875rem"
                fontWeight="500"
                margin="0"
                color={colors.black_80}
              >
                {t('Log in again')}
              </Paragraph>
            </Paragraph>
          }
          additionalContentOnRHS={
            <Paragraph
              fontFamily={fontFamily.semiBold}
              fontSize="0.875rem"
              fontWeight="600"
              color={colors.black_70}
              onClick={() => setCloseWarningAlert(prevState => !prevState)}
              cursor="pointer"
            >
              {t('Mark as read')}
            </Paragraph>
          }
          showAlertCustom={closeWarningAlert}
          showCloseIcon={false}
          margin="0.75rem 0 1.5rem 0"
          backgroundColor={colors.white}
          info
        />
      )}
    </>
  );
};
